import BaseAutocomplete from './baseAutocomplete'
import { IBatch } from 'interfaces/IPremix'
import { formatStockQuantity } from 'components/inventory/helpers'

const headers = [
  {
    id: 'batchNumber',
    numeric: false,
    disablePadding: true,
    label: 'No Bets',
    width: 'medium',
  },
  {
    id: 'currentQuantity',
    numeric: false,
    disablePadding: true,
    label: 'Sisa',
    width: 'medium',
  },
]

export default function LoadBatchAutocomplete(props: {
  name?: string
  onChange?: (ingredient: IBatch) => void
  onInputChange?: (value: string, reason: string) => void
  disabled?: boolean
  required?: boolean
  showInactive?: boolean
  getMatchedData?: (ingredients: IBatch[]) => void
  showDetailedTable?: boolean
  loadAll?: boolean
  premixId?: string
  onlyAvailable?: boolean
  isShowingCreatedBatch?: boolean
  isShowingEmptyBatch?: boolean
}) {
  const {
    name,
    loadAll,
    premixId,
    onlyAvailable,
    isShowingCreatedBatch,
    isShowingEmptyBatch,
  } = props

  let url = '/premix/getBatches'

  const responseMapper = (batch: IBatch) => {
    const stock = formatStockQuantity(batch.currentQuantity ?? 0)
    return `${batch.batchNumber} (Sisa: ${stock})`
  }

  const extraParams: Record<string, any> = {}
  if (premixId) extraParams.premixId = premixId
  if (onlyAvailable) extraParams.onlyAvailable = true
  if (isShowingCreatedBatch) extraParams.isShowingCreatedBatch = true
  if (isShowingEmptyBatch) extraParams.isShowingEmptyBatch = true

  return (
    <BaseAutocomplete
      {...props}
      url={url}
      headers={headers}
      label="Bets"
      loadAll={loadAll}
      name={name}
      responseMapper={responseMapper}
      extraParams={extraParams}
    />
  )
}
